import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import * as PropType from '../common/propType';
import { vote, addShop } from '../../operates';
import { ReturnOrder, PopupComp, MergeOrder } from '../../widgets';
import MeScroll from '../../com/mescroll.min';
import Swiper from '../../com/swiper-3.3.1.min';
import '../../com/swiper-3.3.1.min.css';
import { Modal, toast, alert, MyWifi } from '..';
import { push, get, defaultOption, payReturnUrl } from '../../utils';
import store, { UserStore } from '../../store';
import { orderDetail, NoPaginationList } from '../../model';
import './index.less';

export interface IScrollerFetchable {
    canFetch: boolean;
    fetch: (page) => void;
    list?: any[];
    page: number;
    isLoadOk: any;
}

declare var window: any;
window.isLoadOk = 'ok';

export interface ScrollerPropType extends PropType.StylePropType {
    renderHeader?: () => JSX.Element | JSX.Element[]; // 页面头部
    renderFooter?: () => JSX.Element | JSX.Element[]; // 页面底部
    renderItem?: (data: any, idx: number) => JSX.Element | JSX.Element[]; // 直接遍历
    renderContent?: () => JSX.Element | JSX.Element[]; // 自由遍历
    onScrollStart?: (x, y) => void; // 滑动开始
    onScrollEnd?: (x, y, pagey) => void; // 滑动结束
    onScroll?: (x, y, pagey) => void; // 滑动中
    scrollTo?: (x, y) => void; // 滚动指定位置
    freeHeight?: number; // 底部高度
    prefixCls?: string; // 页面初始样式
    autoFetch?: boolean; // 是否加载
    fetchable: IScrollerFetchable; // 数据
    emptyView?: () => JSX.Element; // 空缺页面
    listStyle?: any;
    listClassName?: string;
    myY?: number;
    myup?: any;
    latext?: any;
    onTap?: any; // 切换
    current?: any; // 切换索引
    user: UserStore; // 用户store
}

/**
 * 订单列表
 * @class Mescroll
 * @extends {React.Component<ScrollerPropType, any>}
 */
@inject('user')
@observer
class Mescroll extends React.Component<ScrollerPropType, any> {
    static defaultProps = {
        prefixCls: 'mescrolls',
        autoFetch: false,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            ordermsg: {},
            isShow: false,
            isReturn: false,
            AjaxData: [], // 全部数据
            AjaxData1: [], // 待支付数据
            AjaxData2: [], // 待发货数据
            AjaxData3: [], // 待收货数据
            AjaxData4: [], // 已收货数据
            AjaxData5: [], // 已完成数据
            firstFetched: false, // 全部是否请求过
            firstFetched1: false, // 待支付是否请求过
            firstFetched2: false, // 待发货是否请求过
            firstFetched3: false, // 待收货是否请求过
            firstFetched4: false, // 已收货是否请求过
            firstFetched5: false, // 已完成是否请求过
            iswlan1: true, // 全部是否有网
            iswlan2: true, // 待支付是否有网
            iswlan3: true, // 待发货是否有网
            iswlan4: true, // 待收货是否有网
            iswlan5: true, // 已收货是否有网
            iswlan6: true, // 已完成是否有网
            payShow: false, // 是否显示合单弹框
            clickFlag: '', // 点击合单时的状态
            isPayFinish: false, // 默认是没有完成支付
            orderId: '',  // 订单号
        };
    }

    private label: HTMLElement;
    private mescroll: HTMLElement;
    private refMap = {
        mescroll: (obj) => this.mescroll = obj,
        label: (obj) => this.label = obj
    };
    AJAX: any;
    AJAX1: any;
    AJAX2: any;
    AJAX3: any;
    AJAX4: any;
    AJAX5: any;
    time: any = null;
    isAjax: boolean = true;
    isclick: boolean = true; // ajax节流
    swiper: any;
    mescrollArr: any = new Array(5);
    payOkDetail: any = orderDetail;
    requestNo = '' + this.props.user.userInfo.id + new Date().getTime(); // 支付流水号
    @observable mergeList: any = NoPaginationList; // 合单数据

    componentDidMount() {
        let that: any = this;
        let { onTap, current } = this.props;
        let curNavIndex: any = current;
        // 5个菜单所对应的5个mescroll对象
        // 初始化首页
        this.mescrollArr[curNavIndex] = initMescroll('mescroll' + curNavIndex, 'dataList' + curNavIndex);

        this.AJAX = new that.props.fetchable({ url: 'order/orders', status: 100 }); // 全部
        this.AJAX1 = new that.props.fetchable({ url: 'order/orders', status: 1 });  // 待支付
        this.AJAX2 = new that.props.fetchable({ url: 'order/orders', status: 2 });  // 待发货
        this.AJAX3 = new that.props.fetchable({ url: 'order/orders', status: 3 });  // 待收货
        this.AJAX4 = new that.props.fetchable({ url: 'order/orders', status: 44 }); // 已收货
        this.AJAX5 = new that.props.fetchable({ url: 'order/orders', status: 4 });  // 已完成

        /* 初始化轮播 */
        this.swiper = new Swiper(this.mescroll, {
            initialSlide: current,
            onTransitionEnd: (swiper: any) => {
                let i: number = swiper.activeIndex; // 轮播切换完毕的事件
                changePage(i);
                location.replace('#!/order/' + i);
                onTap(i, function () {

                });
            }
        });

        /* 初始化菜单 */
        let navp: any = document.querySelectorAll('#nav p');
        let len: number = navp.length;
        for (let i = 0; i < len; i++) {
            navp[i].addEventListener('click', () => {
                let x: any = Number(navp[i].getAttribute('data-i'));
                that.swiper.slideTo(x); // 以轮播的方式切换列表
                location.replace('#!/order/' + x);
            });
        }

        /*切换列表*/
        function changePage(i) {
            if (curNavIndex != i) {
                // 更改列表条件
                let navp: any = document.querySelectorAll('#nav p');
                let len: number = navp.length;
                for (let x = 0; x < len; x++) {
                    if (navp[x].getAttribute('data-i') == i) {
                        navp[x].classList.add('active');
                    } else {
                        navp[x].classList.remove('active');
                    }
                }
                // 隐藏当前回到顶部按钮
                that.mescrollArr[curNavIndex].hideTopBtn();
                // 取出菜单所对应的meScroll对象,如果未初始化则初始化S
                if (that.mescrollArr[i] == null) {
                    that.mescrollArr[i] = initMescroll('mescroll' + i, 'dataList' + i);
                } else {
                    // 检查是否需要显示回到到顶按钮
                    let curMescroll: any = that.mescrollArr[i];
                    let curScrollTop: any = curMescroll.getScrollTop();
                    if (curScrollTop >= curMescroll.optUp.toTop.offset) {
                        curMescroll.showTopBtn();
                    } else {
                        curMescroll.hideTopBtn();
                    }
                }
                // 更新标记
                curNavIndex = i;
            }
        }

        // 创建MeScroll对象
        function initMescroll(mescrollId, clearEmptyId) {
            // 创建MeScroll对象,内部已默认开启下拉刷新,自动执行up.callback,刷新列表数据;
            let mescroll: any = new MeScroll(mescrollId, {
                // 上拉加载的配置项
                up: {
                    callback: getListData, // 上拉回调,此处可简写; 相当于 callback: function (page) { getListData(page); }
                    isBounce: false, // 此处禁止ios回弹,解析(务必认真阅读,特别是最后一点): http://www.mescroll.com/qa.html#q10
                    noMoreSize: 10, // 如果列表已无数据,可设置列表的总数量要大于半页才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看; 默认5
                    page: { size: 10, time: 300 },
                    empty: {
                        warpId: mescrollId,
                        icon: require('../../images/order_empty.png'), // 图标,默认null
                        tip: '您还没有订单' // 提示
                    },
                    // clearEmptyId: clearEmptyId, // 相当于同时设置了clearId和empty.warpId; 简化写法;默认null
                    toTop: {
                        warpId: null,
                        src: require('./img/mescroll-totop.png'), // 默认滚动到1000px显示,可配置offset修改
                        offset: 1000,
                    },
                }
            });
            return mescroll;
        }

        /* 联网加载列表数据  page = {num:1, size:10}; num:当前页 从1开始, size:每页数据条数 */
        function getListData(page) {
            // 联网加载数据
            let dataIndex: any = curNavIndex; //记录当前联网的nav下标,防止快速切换时,联网回来curNavIndex已经改变的情况;
            getListDataFromNet(that, dataIndex, page.num, page.size, function (pageData, hasNext) {
                // 联网成功的回调,隐藏下拉刷新和上拉加载的状态;
                if (that.isAjax) {
                    if (dataIndex == 0) {
                        if (page.num == 1) {
                            that.setState({ AjaxData: [] });
                        }
                        that.setState({ AjaxData: that.state.AjaxData.concat(pageData), firstFetched: true });
                    }
                    if (dataIndex == 1) {
                        if (page.num == 1) {
                            that.setState({ AjaxData1: [] });
                        }
                        that.setState({ AjaxData1: that.state.AjaxData1.concat(pageData), firstFetched1: true });
                    }
                    if (dataIndex == 2) {
                        if (page.num == 1) {
                            that.setState({ AjaxData2: [] });
                        }
                        that.setState({ AjaxData2: that.state.AjaxData2.concat(pageData), firstFetched2: true });
                    }
                    if (dataIndex == 3) {
                        if (page.num == 1) {
                            that.setState({ AjaxData3: [] });
                        }
                        that.setState({ AjaxData3: that.state.AjaxData3.concat(pageData), firstFetched3: true });
                    }
                    if (dataIndex == 4) {
                        if (page.num == 1) {
                            that.setState({ AjaxData4: [] });
                        }
                        that.setState({ AjaxData4: that.state.AjaxData4.concat(pageData), firstFetched4: true });
                    }
                    if (dataIndex == 5) {
                        if (page.num == 1) {
                            that.setState({ AjaxData5: [] });
                        }
                        that.setState({ AjaxData5: that.state.AjaxData5.concat(pageData), firstFetched5: true });
                    }
                }

                // 方法四 (不推荐),会存在一个小问题:比如列表共有20条数据,每页加载10条,共2页.如果只根据当前页的数据个数判断,则需翻到第三页才会知道无更多数据,如果传了hasNext,则翻到第二页即可显示无更多数据.
                // mescrollArr[dataIndex].endSuccess(pageData.length);
                hasNext = hasNext == 0 ? 0 : hasNext;
                if (hasNext) {
                    that.mescrollArr[dataIndex].endSuccess(page.size, hasNext);
                } else {
                    that.mescrollArr[dataIndex].endSuccess(pageData.length, hasNext);
                }
            }, function () {
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                that.mescrollArr[dataIndex].endErr();
            });
        }

        /*
         * 联网加载列表数据
         * 在您的实际项目中,请参考官方写法: http://www.mescroll.com/api.html#tagUpCallback
         * 请忽略getListDataFromNet的逻辑,这里仅仅是在本地模拟分页数据,本地演示用
         * 实际项目以您服务器接口返回的数据为准,无需本地处理分页.
         */
        function getListDataFromNet(_that, curNavIndex, pageNum, pageSize, successCallback, errorCallback) {
            // 延时一秒,模拟联网
            if (curNavIndex == 0) {
                _that.AJAX.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan1: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan1: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
            if (curNavIndex == 1) {
                _that.AJAX1.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan2: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan2: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
            if (curNavIndex == 2) {
                _that.AJAX2.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan3: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan3: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
            if (curNavIndex == 3) {
                _that.AJAX3.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan4: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan4: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
            if (curNavIndex == 4) {
                _that.AJAX4.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan5: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan5: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
            if (curNavIndex == 5) {
                _that.AJAX5.fetch(pageNum, function (data, hasNext) {
                    successCallback(data, hasNext);
                    _that.setState({ iswlan6: true });
                }, function (err) {
                    if (err) {
                        _that.setState({ iswlan6: true });
                        let emptyNode: any = document.getElementsByClassName('mescroll-empty')[0];
                        emptyNode.style.disable = 'none';
                        errorCallback(err);
                    }
                });
            }
        }
    }

    // 调起删除合单弹框
    @autobind
    onDeleteShow(tabIndex, index) {
        this.mergeList = new NoPaginationList({
            url: 'order/payno/info',
            orderId: this.state['AjaxData' + tabIndex][index].orderUuid
        });
        this.mergeList.fetch(d => {
            if (d === null) { // 如果为null，则没有同时下单的单子，直接删除
                this.onDelete(tabIndex, index);
                return false;
            }
            this.setState({
                payShow: !this.state.payShow,
                clickFlag: '删除'
            });
        });
    }

    // 删除订单事件
    @autobind
    onDelete(tabIndex, index, orderId?) {
        let orderIds: any;
        if (!orderId) {
            orderIds = this.state['AjaxData' + tabIndex][index].orderUuid;
        } else {
            orderIds = orderId;
        }
        alert('是否确认删除？', [
            '取消',
            {
                text: '确认删除', onClick: () => {
                    vote('order/delete/id', { orderUuid: orderIds }, '', () => {
                        if (orderId) {
                            this.mescrollArr[tabIndex == '' ? 0 : 1].resetUpScroll(false);
                        } else {
                            this.state['AjaxData' + tabIndex].splice(index, 1);
                            this.setState({
                                ['AjaxData' + tabIndex]: this.state['AjaxData' + tabIndex]
                            });
                        }
                    });
                }
            }
        ]);
    }

    // 调起取消合单弹框
    @autobind
    onCancelShow(tabIndex, index) {
        this.mergeList = new NoPaginationList({
            url: 'order/payno/info',
            orderId: this.state['AjaxData' + tabIndex][index].orderUuid
        });
        this.mergeList.fetch(d => {
            if (d === null) { // 如果为null，则没有同时下单的单子，直接取消
                this.onCancel(tabIndex, index);
                return false;
            }
            this.setState({
                payShow: !this.state.payShow,
                clickFlag: '取消'
            });
        });
    }

    // 取消订单事件
    @autobind
    onCancel(tabIndex, index, orderId?) {
        let orderIds: any;
        if (!orderId) {
            orderIds = this.state['AjaxData' + tabIndex][index].orderUuid;
        } else {
            orderIds = orderId;
        }
        alert('是否取消订单？', [
            '再想想',
            {
                text: '取消订单', onClick: () => {
                    vote('order/cancel/id', { orderUuid: orderIds }, '', () => {
                        if (orderId) {
                            this.mescrollArr[tabIndex == '' ? 0 : 1].resetUpScroll(false);
                        } else {
                            this.state['AjaxData' + tabIndex][index].orderStatus = -1;
                            this.setState({
                                ['AjaxData' + tabIndex]: this.state['AjaxData' + tabIndex]
                            });
                        }
                    });
                }
            },
        ]);
    }

    // 退货事件
    @autobind
    onReturn(tabIndex, data, index) {
        this.showReturn();
    }

    // 收货事件
    @autobind
    onAffirm(tabIndex, index) {
        alert('是否确认收货？', [
            '取消',
            {
                text: '确认收货', onClick: () => {
                    vote('order/receive/id', this.state['AjaxData' + tabIndex][index], '', (data: any, err) => {
                        setTimeout(() => {
                            if (data === true) {
                                toast('确认成功');
                            } else {
                                toast('确认失败');
                            }
                            if (!data) return;
                            if (tabIndex === '') {
                                this.state['AjaxData' + tabIndex][index].orderStatus = 44;
                            } else {
                                this.state['AjaxData' + tabIndex].splice(index, 1);
                                if (this.state['AjaxData' + tabIndex].length === 0) {
                                    this.mescrollArr[tabIndex].showEmpty();
                                }
                            }
                            this.setState({
                                ['AjaxData' + tabIndex]: this.state['AjaxData' + tabIndex]
                            });
                            this.swiper.slideTo(4);
                            location.replace('#!/order/' + 4);
                        }, 10);
                    });
                }
            }
        ]);
    }

    // 查看物流
    @autobind
    onShow(data, index) {
        push(`/logisticsDetail/${data.wayBillId}/${data.expressCompanyName}/${data.expressCompanyPhone}/${data.orderUuid}?originPageId=orderPage`, this);
    }

    // 点击退货
    @autobind
    showReturn() {
        this.setState({
            isReturn: !this.state.isReturn,
        });
    }

    // 点击跳转客服
    @autobind
    onService() {
        push('/my', this);
    }

    // 重新购买
    @autobind
    onRePurchase(tabIndex, index) {
        let that = this;
        let len = this.state['AjaxData' + tabIndex][index].orderItems.length;
        let rechargeNumber = this.state['AjaxData' + tabIndex][index].rechargeNumber;  // 虚拟商品手机充值
        let isBreak = false;
        if (rechargeNumber) {// 虚拟商品手机充值
            let skuId: any = this.state['AjaxData' + tabIndex][index].orderItems[0].skuId;
            let num: any = this.state['AjaxData' + tabIndex][index].orderItems[0].num;
            push('/gobuy/' + skuId + '/1/' + num + '?originType=3' + '&originPageId=order&rechargeNumber=' + rechargeNumber, that);
            window.sessionStorage.setItem('isVirtual', 'true')
        } else {
            window.sessionStorage.setItem('isVirtual', 'false')
            for (let i = 0; i < len; i++) {
                if (isBreak) {
                    break;
                }
                let skuId: any = this.state['AjaxData' + tabIndex][index].orderItems[i].skuId;
                let num: any = this.state['AjaxData' + tabIndex][index].orderItems[i].num;
                let obj: any = Object.assign({}, { data: skuId, selectNumber: num });
                addShop(obj, this.props.user, (isRun) => {
                    isBreak = isRun;
                    if (isRun) return;
                    let skuIdStr: any = sessionStorage.getItem('__shop');
                    if (skuIdStr) {
                        skuIdStr.indexOf(skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + skuId);
                    } else {
                        sessionStorage.setItem('__shop', skuId);
                    }
                    push('/shop', this);
                }, len, i);
            }
        }
    }

    // 取消订单
    @autobind
    onRefresh(tabIndex, index) {
        this.state['AjaxData' + tabIndex][index].orderStatus = -1;
        this.setState({
            ['AjaxData' + tabIndex]: this.state['AjaxData' + tabIndex]
        });
    }

    // 显示支付合单弹框
    @autobind
    onPayShow(tabIndex, index) {
        this.mergeList = new NoPaginationList({
            url: 'order/payno/info',
            orderId: this.state['AjaxData' + tabIndex][index].orderUuid
        });
        this.mergeList.fetch(d => {
            if (d === null) { // 如果为null，则没有同时下单的单子，直接调起微信支付
                this.onPay(tabIndex, index);
                return false;
            }
            this.setState({
                payShow: !this.state.payShow,
                clickFlag: '支付'
            });
        });
    }

    // 关闭支付弹框
    @autobind
    onCloseBox() {
        this.setState({
            payShow: !this.state.payShow
        });
    }

    // 合单弹框底部点击事件
    @autobind
    onEnterClick(data) {
        let orderId: any = data[0].orderUuid;
        if (this.state.clickFlag === '支付') {
            this.onPay(null, null, orderId);
        } else if (this.state.clickFlag === '取消') {
            this.onCancel(null, null, orderId);
        } else if (this.state.clickFlag === '删除') {
            this.onDelete(null, null, orderId);
        }
        this.onCloseBox();
    }

    // 调起支付
    @autobind
    onPay(tabIndex, index, orderId?) {
        let orderIds: any;
        if (!orderId) {
            orderIds = this.state['AjaxData' + tabIndex][index].orderUuid;
        } else {
            orderIds = orderId;
        }
        let that = this;
        that.setState({
            orderId: orderIds  // 订单号
        });
        this.payOkDetail = new orderDetail({
            url: 'pay/p',
            orderIds: orderIds,
            purchaseWay: 2,
            requestNo: that.requestNo,
            transactionType: 5, // web浏览器
            type: payReturnUrl.type,
            balance: 0
        });
        this.payOkDetail.fetch(function (d) {
            let data = d.data;
            if (data) {
                let isIosApp = sessionStorage.getItem("isIosApp")
                let appDBUrl: any = sessionStorage.getItem("iosCBUrl")
                let redirect_url = isIosApp == "1" ? appDBUrl : `${defaultOption.url}?#!/order/1&originPageId=weChat`
                let MWEB_URL = `${data.mwebUrl}&redirect_url=${encodeURIComponent(redirect_url)}`
                window.location.href = MWEB_URL
            } else {
                alert(d.errDesc, ['知道了']);
            }
        });

    }
    onPayZfb = (tabIndex, index, orderId?) => {
        let orderIds: any;
        if (!orderId) {
            orderIds = this.state['AjaxData' + tabIndex][index].orderUuid;
        } else {
            orderIds = orderId;
        }
        let that = this;
        that.setState({
            orderId: orderIds  // 订单号
        });
        this.payOkDetail = new orderDetail({
            url: 'pay/alipaySign',
            orderIds: orderIds,
            purchaseWay: 2,
            requestNo: that.requestNo,
            transactionType: 5, // web浏览器
            type: payReturnUrl.type,
            balance: 0
        });
        this.payOkDetail.fetch(function (d) {
            let data = d.data;
            if (data) {
                let div = document.createElement("div")
                div.innerHTML = data.sign
                document.body.appendChild(div)
                document.forms[0].submit()
            } else {
                that.isclick = true;
                alert(d.errDesc, ['知道了']);
            }
        });
    }

    // 待收货订单修改地址
    @autobind
    onEditAddress(tabIndex, data, index) {
        sessionStorage.setItem('__isChooseAdd', data.receiver.addressUuid);
        sessionStorage.setItem('__receiver', JSON.stringify(data.receiver));
        let orderIds: string = data.orderUuid;
        push(`/add/true/${orderIds}?originPageId=order`, this);
    }

    @autobind
    componentWillUnmount() {
        let { onTap, current } = this.props;
        onTap(current, function () {

        });
        clearTimeout(this.time);
        this.time = null;
        this.isAjax = false;
        this.mescrollArr[current].destroy();
    }

    @autobind
    onFinishPay() {
        let orderId = this.state.orderId;
        let newOrderId: string = orderId.split(',')[0];
        get('order/id', {
            orderId: orderId
        }).then((res) => {
            if (res.errCode === 200) {
                let orderStatus = res.data.orderStatus;
                window.localStorage.removeItem('isGameOrderPayFinished');
                if (orderStatus === 2) {
                    push('/payok/1/' + newOrderId + `?orderIds=${orderId}`, this, true);
                } else {
                    push('/payok/0/' + newOrderId, this, true);
                }
            } else {
                toast(res.errMsg);
            }
        }).catch(() => {
            toast('订单异常');
        });
    }
    // 选择支付方式
    onSelectPayType = (type) => {
        this.setState({
            payType: type
        })
    }
    render() {
        let { renderHeader } = this.props;
        return (
            <div className={this.props.prefixCls}>
                {renderHeader && renderHeader()}
                <div
                    id="swiper"
                    className="swiper-container swiper-container1"
                    style={{ top: store.status.isShowHead ? '9.7rem' : '4rem' }}
                    ref={this.refMap.mescroll}
                >
                    <div className="swiper-wrapper">
                        <div id="mescroll0" className="swiper-slide mescroll">
                            {
                                !this.state.iswlan1 ? <MyWifi /> :
                                    <ul id="dataList0" className="data-list">
                                        {this.state.AjaxData.map((item, index) => {
                                            return (
                                                <ReturnOrder
                                                    data={item}
                                                    key={index}
                                                    index={index}
                                                    onDelete={(index) => {
                                                        this.onDeleteShow('', index);
                                                    }}
                                                    onCancel={(index) => {
                                                        this.onCancelShow('', index);
                                                    }}
                                                    onReturn={(data, index) => {
                                                        this.onReturn('', data, index);
                                                    }}
                                                    onAffirm={(index) => {
                                                        this.onAffirm('', index);
                                                    }}
                                                    onShow={this.onShow} current={this.props.current}
                                                    onRePurchase={(index) => {
                                                        this.onRePurchase('', index);
                                                    }}
                                                    onRefresh={(index) => {
                                                        this.onRefresh('', index);
                                                    }}
                                                    onPay={(index) => {
                                                        this.onPayShow('', index);
                                                    }}
                                                    onEditAddress={(data) => {
                                                        this.onEditAddress('', data, index);
                                                    }}
                                                    onPayZfb={(index) => this.onPayZfb('', index)}
                                                />
                                            );
                                        })}
                                    </ul>
                            }
                        </div>
                        <div id="mescroll1" className="swiper-slide mescroll">
                            {!this.state.iswlan2 ? <MyWifi /> :
                                <ul id="dataList0" className="data-list">
                                    {
                                        this.state.AjaxData1.map((item, index) => {
                                            return (
                                                <ReturnOrder
                                                    data={item}
                                                    key={index}
                                                    index={index}
                                                    current={this.props.current}
                                                    onDelete={(index) => {
                                                        this.onDeleteShow('1', index);
                                                    }}
                                                    onCancel={(index) => {
                                                        this.onCancelShow('1', index);
                                                    }}
                                                    onRefresh={(index) => {
                                                        this.onRefresh('1', index);
                                                    }}
                                                    onPay={(index) => {
                                                        this.onPayShow('1', index);
                                                    }}
                                                    onPayZfb={(index) => this.onPayZfb('', index)}
                                                />
                                            );
                                        })}
                                </ul>
                            }
                        </div>
                        <div id="mescroll2" className="swiper-slide mescroll">
                            {!this.state.iswlan3 ? <MyWifi /> :
                                <ul id="dataList2" className="data-list">
                                    {
                                        this.state.AjaxData2.map((item, index) => {
                                            return (
                                                <ReturnOrder
                                                    data={item} key={index} index={index}
                                                    current={this.props.current}
                                                    onReturn={(data, index) => {
                                                        this.onReturn('2', data, index);
                                                    }}
                                                    onEditAddress={(data) => {
                                                        this.onEditAddress('2', data, index);
                                                    }}
                                                    onRefresh={(index) => {
                                                        this.onRefresh('2', index);
                                                    }}
                                                />);
                                        })}
                                </ul>
                            }
                        </div>
                        <div id="mescroll3" className="swiper-slide mescroll">
                            {!this.state.iswlan4 ? <MyWifi /> : <ul id="dataList3" className="data-list">
                                {
                                    this.state.AjaxData3.map((item, index) => {
                                        return (
                                            <ReturnOrder
                                                data={item}
                                                key={index}
                                                index={index}
                                                onShow={this.onShow}
                                                onAffirm={(index) => {
                                                    this.onAffirm('3', index);
                                                }} current={this.props.current}
                                            />);
                                    })}
                            </ul>}
                        </div>
                        <div id="mescroll4" className="swiper-slide mescroll">
                            {!this.state.iswlan5 ? <MyWifi /> :
                                <ul id="dataList4" className="data-list">
                                    {this.state.AjaxData4.map((item, index) => {
                                        return (
                                            <ReturnOrder
                                                data={item}
                                                key={index}
                                                index={index}
                                                current={this.props.current}
                                                onReturn={(data, index) => {
                                                    this.onReturn('4', data, index);
                                                }}
                                                onRePurchase={(index) => {
                                                    this.onRePurchase('4', index);
                                                }}
                                                onShow={this.onShow}
                                            />);
                                    })}
                                </ul>
                            }
                        </div>
                        <div id="mescroll5" className="swiper-slide mescroll">
                            {!this.state.iswlan5 ? <MyWifi /> :
                                <ul id="dataList5" className="data-list">
                                    {this.state.AjaxData5.map((item, index) => {
                                        return (
                                            <ReturnOrder
                                                data={item}
                                                key={index}
                                                index={index}
                                                current={this.props.current}
                                                onReturn={(data, index) => {
                                                    this.onReturn('5', data, index);
                                                }}
                                                onRePurchase={(index) => {
                                                    this.onRePurchase('5', index);
                                                }}
                                                onShow={this.onShow}
                                            />);
                                    })}
                                </ul>
                            }
                        </div>
                    </div>
                </div>
                {this.state.isReturn && (
                    <Modal onClose={this.showReturn}>
                        <PopupComp data={this.props.user ? this.props.user.shopInfo : {}} onClick={this.showReturn} />
                    </Modal>
                )}
                {
                    this.state.payShow ?
                        <MergeOrder
                            isShow={this.state.payShow}
                            onCloseBox={this.onCloseBox}
                            data={this.mergeList.list}
                            clickFlag={this.state.clickFlag}
                            onEnterClick={this.onEnterClick}
                        />
                        :
                        null
                }
                <div className={'pay_fail_box'} style={{ display: this.state.isPayFinish ? 'flex' : 'none' }}>
                    <div className={'pay_fail_success'} onClick={this.onFinishPay}>已完成支付</div>
                    <div className={'pay_fail_question'} onClick={this.onFinishPay}>支付遇到问题</div>
                </div>
                <div className={'pay_fail_pop'} style={{ display: this.state.isPayFinish ? 'flex' : 'none' }} />
            </div>
        );
    }

    canFetch() {
        let { fetchable } = this.props;
        if (fetchable) {
            return fetchable.canFetch;
        }
        return false;
    }
}

export default Mescroll;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/mescroll/index.tsx